import { createSlice } from "@reduxjs/toolkit";

export const lookupSlice = createSlice({
  name: "lookupDetails",
  initialState: {},
  reducers: {
    setCountryList: (state, action) => {
      state.countryList = action.payload;
    },
    setStateList: (state, action) => {
      state.stateList = action.payload;
    },
    setDistrictList: (state, action) => {
      state.districtList = action.payload;
    },
    setMunicipalityList: (state, action) => {
      state.municipalityList = action.payload;
    },
    setBankList: (state, action) => {
      state.bankList = action.payload;
    },
    setBankAccountTypeList: (state, action) => {
      state.bankAccountTypeList = action.payload;
    },
    setBusinessTypeList: (state, action) => {
      state.businessTypeList = action.payload;
    },
    setCompanyTypeList: (state, action) => {
      state.companyTypeList = action.payload;
    },
    setDesignationList: (state, action) => {
      state.designationList = action.payload;
    },
    setRelationTypeList: (state, action) => {
      state.relationTypeList = action.payload;
    },
    setFinancialDetailsList: (state, action) => {
      state.financialDetailsList = action.payload;
    },
    setOccupationTypeList: (state, action) => {
      state.occupationTypeList = action.payload;
    },
    setDocumentTypeList: (state, action) => {
      state.documentTypeList = action.payload;
    },
    setDpList: (state, action) => {
      state.dpList = action.payload;
    },
    setDirectorTypeList: (state, action) => {
      state.directorTypeList = action.payload;
    },
    setErrorList: (state, action) => {
      state.errorList = action.payload;
    },
    setBankBranchList: (state, action) => {
      state.bankBranchList = action.payload;
    },
  },
});

export const {
  setCountryList,
  setStateList,
  setDistrictList,
  setMunicipalityList,
  setBankList,
  setBankAccountTypeList,
  setBusinessTypeList,
  setCompanyTypeList,
  setDesignationList,
  setRelationTypeList,
  setFinancialDetailsList,
  setOccupationTypeList,
  setDocumentTypeList,
  setDpList,
  setDirectorTypeList,
  setErrorList,
  setBankBranchList,
} = lookupSlice.actions;

export default lookupSlice.reducer;
